import { useEffect } from "react";

export function stopDictationIfInactive(
  isActive: boolean | undefined,
  isRecording: boolean,
  isMicroLoading: boolean,
  stopRecording: () => void
): void {
  if (isActive === false && (isRecording || isMicroLoading)) {
    stopRecording();
  }
}

export function useStopDictationIfInactive(
  isActive: boolean | undefined,
  isRecording: boolean,
  isMicroLoading: boolean,
  stopRecording: () => void
): void {
  useEffect(() => {
    stopDictationIfInactive(isActive, isRecording, isMicroLoading, stopRecording);
  }, [isActive, isRecording, isMicroLoading, stopRecording]);
}
